<div class="alert alert-danger d-flex align-items-center p-2" role="alert">
  <span class="mts-icon mx-2 error-icon">error</span>
  <div class="fs-verysmall">
    {{  message }}
    @if (linkText) {
      <app-link (click)="selected($event)" [title]="linkText" [style]="'alert'" [noPadding]="true">{{ linkText }}</app-link>
    }
  </div>
</div>
